<template>
  <div id="app">
    <keep-alive include="pay,openCard,rechargeCard">
      <router-view></router-view>
    </keep-alive>
    <!--<router-view v-if="!$route.meta.keepAlive"></router-view>-->
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import login from './util/login'
  export default {
    data() {
      return {
        source: '',
        query: ''
      };
    },
    computed: {
      ...mapState(['isApp', 'openId', 'jsCode', 'storeIdStr', 'brandIdStr', 'userToken']),
    },
    created () {
      console.log('isApp', this.isApp)
      this.$store.commit('userToken', '')
      this.getUserAgent()
    },
    mounted () {
      console.log('app---mounted')
      setTimeout(() => {
        this.AndroisIos()
      }, 1500)
    },
    methods: {
      AndroisIos () {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        if (isAndroid) {
          this.getUserAgent()
        }
      },
      getUserAgent () {
        let ua = navigator.userAgent.toLowerCase();
        console.log('ua', ua)
        let isAlipay = ua.indexOf("alipayclient") !== -1;
        window.isAlipay = isAlipay
        let isWeixin = ua.indexOf("micromessenger") !== -1;
        window.isWeixin = isWeixin
        if (window.isAlipay) {
          this.$store.commit('isApp', 'isAlipay')
          this.doLogin()
        } else  if (window.isWeixin) {
          this.$store.commit('isApp', 'isWeixin')
          this.doLogin()
        } else {
					this.$toast('H5只能在微信或支付宝用打卡!')
        }
      },
      doLogin () {
        login().then((res) => { // res是微信登陆信息
          console.log('doLogin', res)
          const { userToken, openId } = res.data
          console.log('doLogin ------userToken', userToken)
          console.log('doLogin ------openId', openId)
          console.log('state ------userToken', this.$store.state.userToken)
          this.$eventHub.$emit('authDone')
          // this.getQuery()
        }).catch((err) => {
          this.$eventHub.$emit('authDone', {
            success: false,
            res: null,
            err: err
          })
        })
      }
      // getQuery () {
      //   let query = this.$route.query
      //   this.query = query
      //   const {storeId = '', brandId = ''} = query
      //   this.$store.commit('storeIdStr', storeId)
      //   this.$store.commit('brandIdStr', brandId)
      //   this.$eventHub.$emit('authDone')
      // }
    }
  }
</script>

<style lang="stylus">
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #232323
  min-height 100vh
.container
  /*padding-top 46px*/
  min-height 100vh
  box-sizing border-box
  line-height 1.1
  font-size 14px
  color #333
  background #ECEDEC
  .van-nav-bar
    position fixed
    top 0
    left 0
    right 0

</style>
